import http from "../../utils/http";
import {
  toast
} from "../../utils/toast";

export const getPartnerSite = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/partner/site/${companyIdx}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 홈페이지 정보 수정
export const modifyPartnerSite = (idx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/partner/site/${idx}`, params)
      .then((res) => {
        toast.success('홈페이지 내용이 적용 되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 홈페이지 생성
export const createPartnerSite = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/partner/site`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const urlDuplicationCheck = (idx, url) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/partner/site/duplication/${idx}`, { url })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};